import { useState } from 'react';
import ssf from '@elliemae/em-ssf-guest';

interface UseSmartClientLoanUpdateResult {
  triggerRefreshPartnerUi: number;
  refreshUI: () => void;
  subscribeToLoanModalChange: (callbackFn: () => void) => Promise<void>;
  unsubscribeLoanModalChange: () => Promise<void>;
}

export function useSmartClientLoanUpdate(): UseSmartClientLoanUpdateResult {
  const [token, setToken] = useState<any>(null);
  const [triggerRefreshPartnerUi, setTriggerRefreshPartnerUi] = useState(0);

  const subscribeToLoanModalChange = async (callbackFn: () => void) => {
    try {
      const loan = await ssf.getObject('loan');
      const loanCommmittedToken = loan.committed.subscribe(callbackFn);
      setToken(loanCommmittedToken);
      return loanCommmittedToken;
    } catch (error) {
      console.error({ error });
    }
  };

  const unsubscribeLoanModalChange = async () => {
    try {
      const loan = await ssf.getObject('loan');
      if (token) {
        loan.committed.unsubscribe(token);
      }
    } catch (error) {
      console.error({ error });
    }
  };

  const refreshUI = () => {
    setTriggerRefreshPartnerUi((prev) => prev + 1);
  };

  return {
    subscribeToLoanModalChange,
    unsubscribeLoanModalChange,
    triggerRefreshPartnerUi,
    refreshUI,
  };
}
